import { useFeatureAnnouncementsStore } from '@/stores/useFeatureAnnouncementsStore';
import { useGetStartedStore } from '@/stores/useGetStartedStore';

/**
 * Runs on every route resolution (login and plain page refresh both re-trigger this,
 * not just a distinct "login event") so the Feature Announcement modal/panel always
 * reflect current eligibility. Hydration is idempotent/cheap to repeat — seenIds and
 * firstEligibleDates are always persisted immediately after any mutation elsewhere
 * (e.g. markSeen), so re-loading from localStorage here never loses data. Order
 * matters: firstEligibleDates must be hydrated before recording new pins, otherwise
 * a pin made this run would be recorded onto stale (pre-hydration) state.
 *
 * The onboarding checklist store's hydration rides along at the same app-init hook
 * point, for the same reason: it's the earliest per-route point where every carrier's
 * localStorage state needs to be loaded before anything reads it.
 */
export default defineNuxtRouteMiddleware(() => {
  const featureAnnouncementsStore = useFeatureAnnouncementsStore();
  const getStartedStore = useGetStartedStore();

  featureAnnouncementsStore.hydrateSeenIds();
  featureAnnouncementsStore.hydrateFirstEligibleDates();
  featureAnnouncementsStore.recordFirstEligibleDates();

  getStartedStore.hydrate();
});
